<div class="col-md-12 p-0 mt-2 mobile-margin-top">
  <app-desktop-reporter-news-card [onHomeNewsPage]="true"></app-desktop-reporter-news-card>

  <div class="d-flex mb-1 clean-horizontal-scroll">
    <app-dropdown-filter [filter]="homeNewsTabService.sexFilter"
                         [resettable]="false"
                         (selectionChange)="homeNewsTabService.onSexFilterSelectionChange($event)">
    </app-dropdown-filter>
    <app-dropdown-filter [filter]="homeNewsTabService.stateFilter"
                         (selectionChange)="homeNewsTabService.onStateFilterSelectionChange($event)"></app-dropdown-filter>
    <app-dropdown-filter *ngIf="homeNewsTabService.stateFilter.active"
                         [filter]="homeNewsTabService.leagueFilter"
                         (selectionChange)="homeNewsTabService.onLeagueFilterSelectionChange($event)">
    </app-dropdown-filter>
  </div>

  <app-news-list *ngIf="homeNewsTabService.newsEntries"
                 [newsEntries]="homeNewsTabService.newsEntries"></app-news-list>
  <div class="spinner-container" *ngIf="homeNewsTabService.loading">
    <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
  </div>
  <div class="col-md-12 p-0 text-center"
       *ngIf="!homeNewsTabService.loading && homeNewsTabService.newsEntries?.length === 0">
    <p>Keine News vorhanden</p>
  </div>
  <button *ngIf="!homeNewsTabService.loading && homeNewsTabService.moreEntriesAvailable"
          mat-raised-button class="news-load-more" (click)="onLoadMore()">
    Weitere Einträge laden
  </button>
</div>
